var _effectorFileName = "/builds/gmini/front-ui-kit/src/MacosExplorer/utils.ts";
import { ROOT_ELEMENT_KEY } from './MacosExplorer.types';
export function filterNotExistingActive(data, active) {
  const result = [];

  function recursive(d, depth) {
    const curActItem = active[depth];

    if (!curActItem) {
      return;
    }

    for (const it of d) {
      const found = it.key === curActItem;

      if (found) {
        result.push(curActItem);

        if (it.children) {
          recursive(it.children, depth + 1);
        } // если пошли по одной ветке, то другие не рассматриваем (ключи на всех уровнях должны быть одинаковыми)


        break;
      }
    }
  }

  recursive(data, 0);
  return result;
} // export function findInTree<T>(
//   tree: ExplorerItemData<T>[],
//   func: (item: ExplorerItemData<T>) => boolean,
// ): ExplorerItemData<T> | undefined {
//   let elem: ExplorerItemData<T> | undefined
//   function recursive(d: ExplorerItemData<T>[]) {
//     for (const it of d) {
//       if (func(it)) {
//         elem = it
//         break
//       }
//       if (it.children) {
//         recursive(it.children)
//       }
//     }
//   }
//   recursive(tree)
//   return elem
// }

export function fromRefs(d, refs) {
  const result = [];

  function recursive(items) {
    items.forEach(item => {
      var _item$children;

      if (refs.includes(item.key)) {
        result.push(item);
      }

      if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
        recursive(item.children);
      }
    });
  }

  recursive(d);
  return result;
}
export function toRefs(d) {
  return d.map(({
    key
  }) => key);
}
export function findParents(d, item) {
  let result = [];

  function recursive(items, parents) {
    items.forEach(it => {
      if (it.key === item.key) {
        result = parents;
      } else if (it.children) {
        recursive(it.children, [...parents, it]);
      }
    });
  }

  recursive(d, []);
  return result;
}
export function withRoot(source, {
  skeletonTotal
}) {
  return [{
    key: ROOT_ELEMENT_KEY,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: null,
    skeletonTotal,
    children: source
  }];
}
export function withRootLoading(src, loading) {
  if (loading && !src[ROOT_ELEMENT_KEY]) {
    return { ...src,
      [ROOT_ELEMENT_KEY]: true
    };
  } else if (!loading && src[ROOT_ELEMENT_KEY]) {
    const next = { ...src
    };
    delete next[ROOT_ELEMENT_KEY];
    return next;
  }

  return src;
}